'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initSubscribers = undefined;

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _modal = require('./modal');

var _cart = require('./cart');

var _product = require('./product');

var _lineItem = require('./line-item');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initSubscribers = exports.initSubscribers = function initSubscribers() {
  PubSub.subscribe(_Constants2.default.updateInlineCartUI, function (message, data) {
    return (0, _lineItem.initLineItemContainers)(data);
  });

  PubSub.subscribe(_Constants2.default.updateProductQuantity, function (message, data) {
    return (0, _product.updateProductQuantity)(data);
  });

  PubSub.subscribe(_Constants2.default.updateLineItemQuantity, function (message, data) {
    return (0, _lineItem.updateLineItemQuantity)(data);
  });

  PubSub.subscribe(_Constants2.default.updateOptionGroupValue, function (message, data) {
    return (0, _product.updateOptionGroupValue)(data);
  });

  PubSub.subscribe(_Constants2.default.updateVariant, function (message, data) {
    return (0, _product.updateVariant)(data);
  });

  PubSub.subscribe(_Constants2.default.updateInventory, function (message, data) {
    return (0, _product.updateInventory)(data);
  });

  PubSub.subscribe(_Constants2.default.updatePrice, function (message, data) {
    return (0, _product.updatePrice)(data);
  });

  PubSub.subscribe(_Constants2.default.showModal, function (message, data) {
    return (0, _modal.updateModal)(data);
  });

  PubSub.subscribe(_Constants2.default.hideModal, function (message, data) {
    return (0, _modal.updateModal)(data);
  });

  PubSub.subscribe(_Constants2.default.cartRequestSuccess, function (message, data) {
    return (0, _cart.updateCart)(data);
  });
};